import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { resolveRouteMeta } from "@/lib/route-meta";

const upsertMeta = (name: string, content: string) => {
  let tag = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null;
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("name", name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
};

export default function RouteMeta() {
  const { pathname } = useLocation();

  useEffect(() => {
    const meta = resolveRouteMeta(pathname);
    document.title = meta.title;
    upsertMeta("robots", meta.robots);

    if (meta.description) {
      upsertMeta("description", meta.description);
    }
  }, [pathname]);

  return null;
}
